const Voyage = () => import('Views/voyage/voyage');

export default[
  { path: '/voyage/voyage/:id', component: Voyage },
];



// WEBPACK FOOTER //
// ./src/router/voyage.js